import { apiFetch } from "../useApi";

export default async function patchDevice({ deviceId, deviceInfo }) {
  const response = await apiFetch(`/devices/${deviceId}`, {
    method: 'PATCH',
    body: JSON.stringify({ name: deviceInfo.name ?? '' }),
  });
}
